import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { scrubber, scrubberContainer } from "./Scrubber.module.scss";

const Scrubber = ({ className, left, onMouseDown }) => {
  return (
    <div className={scrubberContainer} style={{ transform: `translate3d(${left}px, 0, 0)` }} onMouseDown={onMouseDown}>
      <div className={classNames(scrubber, className)} />
    </div>
  );
};

Scrubber.propTypes = {
  left: PropTypes.number,
  onMouseDown: PropTypes.func,
  className: PropTypes.string
};

Scrubber.defaultProps = {
  left: 0,
  onMouseDown: () => {},
  className: ""
};

export default Scrubber;
